// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import _, {get} from 'lodash';
import React, {Component, PropTypes} from 'react';
import {Link} from 'react-router';
import {push} from 'react-router-redux';
import {stringify as queryStringify} from 'querystring';

// utilities
import cx from 'classnames';
import { connect } from 'react-redux';

@connect(store => {
  return {
    viewOrder: get(store, 'labels.viewOrder', [])
  };
})
export default class SubNav extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onChangeStep: PropTypes.func.isRequired,
    activeStepIndex: PropTypes.number.isRequired,
    route: PropTypes.object.isRequired,
    style: PropTypes.object,
    viewOrder: PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
  }

  render() {



    const activeStepKey = (this.props.viewOrder[this.props.activeStepIndex] || {}).key;
    const basePath = `/admin/${this.props.route.params.navColumnState}/${this.props.route.params.email}`;
    const queryString = `?${queryStringify(this.props.route.query)}`;


    return (
        <div className='subnav' style={this.props.style}>
          <ul className='subnav-link-container'>
            {
              this.props.viewOrder.map((navItem, index) =>
                <li
                  key={index}
                  data-id={navItem.key}
                  className={cx('subnav-link', 'link', {active: navItem.key === this.props.route.params.category })}
                  onClick={this.props.onChangeStep.bind(this, index, `${basePath}/${navItem.key}${queryString}`)}
                >
                    {navItem.display}
                </li>
              )
            }
            <li
              data-id={'References'}
              className={cx('subnav-link', 'link', {active: this.props.activeStepIndex === 3})}
              onClick={this.props.onChangeStep.bind(this, 3, `${basePath}/References${queryString}`)}
              >
              References
            </li>
            <li
              data-id={'Technology Survey'}
              className={cx('subnav-link', 'link', {active: this.props.activeStepIndex === 4})}
              onClick={this.props.onChangeStep.bind(this, 4, `${basePath}/TechnologySurvey${queryString}`)}
              >
              Tech Survey
            </li>
          </ul>
        </div>
    );
  }

}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/f_SubNav/index.js